import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Components
import { SelectivePreloadingStrategy } from './selective-preloading-strategy';
import { PageNotFoundComponent } from './not-found.component';
import { AuthGuard } from './services/auth-guard.service';

const routes: Routes = [
  // logged routes
  {
    path: '',
    loadChildren: './pages/layout/layout.module#LayoutModule',
    canActivate: [AuthGuard]
  },
  // not logged routes
  {
    path: 'login',
    loadChildren: './pages/login/login.module#LoginModule'
  },
  { path: '**', component: PageNotFoundComponent }
];

export const routing: ModuleWithProviders = RouterModule.forRoot(routes, { preloadingStrategy: SelectivePreloadingStrategy, useHash: true });



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sms-server-fe-release-v2.1.8.3/src/app/app.routes.ts